/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/jsx-wrap-multilines */
import React from "react";
import { fade, makeStyles } from "@material-ui/core/styles";
import { TextFieldProps, TextField, Grid, Tooltip } from "@material-ui/core";
import { ViewModeTextField } from "./ViewModeTextField";
import { IconTooltip } from "../../icons/IconTooltip";

const useStylesInput = makeStyles(theme => ({
  root: {
    "label + &": {
      marginTop: "5px"
    }
  },
  input: {
    borderRadius: 4,
    position: "relative",
    // border: "1px solid",
    borderColor: "#cad1d7",
    border: "1px solid #cad1d7",
    fontSize: 14,
    padding: "13px 14px",
    color: "#323536",
    alignSelf: "flex-end",
    transition: theme.transitions.create(["box-shadow"]),
    "&:focus": {
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
      "text-decoration-line": "none"
    }
  }
}));

const useStyles = makeStyles(_theme => ({
  labelRequired: {
    color: "#f75676",
    // marginLeft: "4px",
    paddingLeft: "3px",
    fontSize: "12px",
    paddingTop: 1
    // marginBottom: "4px"
  },
  labelRequiredComments: {
    color: "#f75676",
    marginLeft: "4px",
    fontSize: "12px",
    marginBottom: "4px",
    marginTop: "5px"
  },
  iconInfo: {
    width: "16px !important",
    height: "16px !important",
    color: "#32325d",
    "&:hover": {
      color: "#5e72e4"
    }
  },
  commentBox: {
    marginTop: "20px",
    "& label": {
      width: "100%",
      "& div": {
        "& input": {
          marginBottom: "20px"
        }
      }
    }
  },
  labelInformation: {
    fontSize: 12,
    fontWeight: 600,
    color: "#8897aa",
    lineHeight: "16px",
    // height: "14px",
    "&:hover": {
      color: "#5e72e4"
    },
    display: "inline-block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "95%",
    textOverflow: "ellipsis",
    pointerEvents: "all"
  },
  iconInfoContainer: {
    height: "16px",
    textAlign: "end"
  },
  tooltip: {
    color: "#32325d",
    backgroundColor: "white",
    fontFamily: `"Open Sans", sans-serif !important`,
    fontSize: 12,
    boxShadow: "0 2px 12px 0 rgba(50, 50, 93, 0.21)",
    padding: "5px"
  },
  arrow: {
    color: "white"
  },
  labelContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // marginTop: "1px",
    width: "100%"
  }
}));

export function TextFieldForm(
  props: TextFieldProps & {
    labelHeader?: string;
    valueTestId?: string;
    inputStyle?: any;
    isViewMode?: boolean;
    infoIconData?: any;
    editedLabel?: any;
    editedData?: any;
    notRequired?: boolean;
    viewtextStyles?: any;
    enableReason?: boolean;
    showEditHistoryOnLine?: boolean;
    fromSettelement?: boolean;
    isServicerMandatory?: boolean;
    onReasonBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  }
) {
  const {
    style,
    inputStyle,
    valueTestId,
    error,
    label,
    isViewMode,
    infoIconData,
    editedLabel,
    editedData,
    onBlur,
    notRequired,
    viewtextStyles,
    showEditHistoryOnLine,
    enableReason = false,
    fromSettelement,
    isServicerMandatory,
    onReasonBlur,
    ...remainingProps
  } = props;
  const inputClasses = useStylesInput();
  const classes = useStyles();
  const cookievalue = `; ${document.cookie}`;
  // eslint-disable-next-line no-useless-concat
  const parts = cookievalue.split("; " + "loginFlow" + "=");
  let loginflow;
  if (parts.length === 2) {
    loginflow = parts
      ?.pop()
      ?.split(";")
      ?.shift();
  } else {
    loginflow = null;
  }

  const isLATUser = loginflow === "LAT";
  return isViewMode ? (
    <ViewModeTextField
      label={label}
      style={style}
      infoIconData={infoIconData}
      value={remainingProps.value}
      editedLabel={editedLabel}
      editedData={editedData}
      viewtextStyles={viewtextStyles}
      showEditHistoryOnLine={showEditHistoryOnLine}
      fromSettelement={fromSettelement}
      valueTestId={valueTestId}
      isServicerMandatory={isServicerMandatory}
    />
  ) : (
    <div
      style={{
        width: "100%"
      }}
    >
      <TextField
        InputProps={{ classes: inputClasses }}
        label={
          <Grid item xs={12} md={12} sm={12} container>
            <Grid item xs={10} sm={10} md={infoIconData ? 11 : 12}>
              <div
                style={{
                  display: "flex"
                }}
              >
                <Tooltip
                  title={`${label}`}
                  placement="right"
                  arrow
                  classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow
                  }}
                >
                  <span className={classes.labelInformation}>{label}</span>
                </Tooltip>
                {!notRequired ? (
                  <span className={classes.labelRequired}>
                    <sup>*</sup>
                  </span>
                ) : null}
              </div>
            </Grid>
            {infoIconData ? (
              <Grid
                item
                xs={2}
                sm={2}
                md={1}
                className={classes.iconInfoContainer}
              >
                <IconTooltip topic="Information" infoIconData={infoIconData} />
              </Grid>
            ) : (
              ""
            )}
          </Grid>
        }
        InputLabelProps={{
          shrink: true,
          style: {
            position: "relative",
            fontWeight: 600,
            fontSize: 12,
            color: "#8897aa",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis"
          }
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...remainingProps}
        error={error}
        // eslint-disable-next-line react/jsx-no-duplicate-props
        inputProps={{
          "data-testid": valueTestId ?? "selection-value",
          style: { borderColor: error ? "#f75676" : "#cad1d7", ...inputStyle }
        }}
        onBlur={onBlur}
        style={{
          flex: 1,
          width: "100%",

          // margin: 4,
          ...style
        }}
      />
      {(editedLabel && isLATUser) || (editedLabel && enableReason) ? (
        <TextField
          InputProps={{ classes: inputClasses }}
          className={classes.commentBox}
          InputLabelProps={{
            style: {
              position: "relative",
              fontWeight: 600,
              fontSize: 12,
              color: "#32325d",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis"
            }
          }}
          onBlur={onReasonBlur || onBlur}
          label={
            <Grid
              container
              item
              xs={12}
              sm={12}
              className={classes.labelContainer}
            >
              <Grid item xs={12} md={12} sm={11} container>
                {/* <span className={classes.labelInformation}> */}
                <Tooltip
                  title={`${label}`}
                  placement="right"
                  arrow
                  classes={{
                    tooltip: classes.tooltip,
                    arrow: classes.arrow
                  }}
                >
                  <span className={classes.labelInformation}>
                    {`Reason For Editing ${label}`}
                  </span>
                </Tooltip>
                <span className={classes.labelRequired}>
                  <sup>*</sup>
                </span>
                {/* </span> */}
              </Grid>
            </Grid>
          }
          style={{
            flex: 1,
            width: "100%",
            marginTop: "20px !important",
            ...style
          }}
        />
      ) : (
        ""
      )}
    </div>
  );
}
